/** * @name: LayoutLeftMenu * @author: weiyong * @date: 2022-10-01 08:42 *
@description：LayoutLeftMenu * @update: 2022-10-01 08:42 */
<template>
  <div :class="[prefixCls, 'LayoutLeftMenu-'+getMenuTheme,bgColorThem, getCollapsed ? 'mix' : 'expand']">
    <div class="title-bar vben-layout-menu-logo" style="display: flex; padding: 6px 1px">
      <appLogo :showLogo="getShowLogo"  :showTitle="getShowSystemTitle!==false" style="height: 48px"></appLogo>
    </div>

    <div :class="prefixCls + '-menu-body'">
      <ul class="arch-menu">
        <template v-for="item in permissionStore.getFrontMenuList" :key="item.path">

          <li @click="openApp(item)" class="arch-menu-item" tabindex="0">
            <span class="arch-menu-item-icon">
              <Icon v-if="item.icon" :icon="item.icon" :size="16" />
              <i v-else :class="item.source || 'gm going-icon-wenjian2-xian'"></i>
            </span>
            <span class="arch-menu-item-text" v-if="!getCollapsed">{{ t(item.name) }}</span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
  export default {
    name: 'LayoutLeftMenu',
  };
</script>

<script lang="ts" setup>
  import Icon from '@/components/Icon/index';
  import {StorageUtils} from 'xmgoing-utils'
  import { HomeOutlined } from '@ant-design/icons-vue';
  import { computed, ref, toRef, unref } from 'vue';
  import { useDesign } from '@/hooks/web/useDesign';
  import { useRouter } from 'vue-router';
  import { useMenuSetting } from '@/hooks/setting/useMenuSetting';
  import AppLogo from '@/components/Application/src/AppLogo.vue';
  import { useGlobSetting } from '@/hooks/setting';
  import { useSplitMenu } from '@/layouts/default/menu/useLayoutMenu';
  import { usePermissionStore } from '@/store/modules/permission';
  import { useI18n } from 'vue-i18n';
  import {useRootSetting} from "@/hooks/setting/useRootSetting";
  import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";

  const { prefixCls } = useDesign('layout-left-menu');
  const {
    getMenuTheme
  } = useMenuSetting();
  const { t } = useI18n();
  const {  getShowLogo } = useRootSetting();

  const permissionStore = usePermissionStore();

  const { title } = useGlobSetting({});
  const { getCollapsed, getSplit, getMenuFixed, getIsMixMode, getMenuBgColor } = useMenuSetting();

  const getSiderClass = computed(() => {
    return [
      prefixCls,
      {
        [`${prefixCls}--fixed`]: unref(getMenuFixed),
        [`${prefixCls}--mix`]: unref(getIsMixMode),
      },
    ];
  });

  const emit = defineEmits(['changeLayout']);
  const router = useRouter();
  //打开子应用
  const openApp = (item) => {
    StorageUtils.addSessionItem("appName",item.name);
    emit('changeLayout', { item });
  };

  const bgColorThem = computed(() => {
    if (getMenuBgColor.value === '#ffffff') {
      return 'lightMenu';
    } else {
      return 'drakMenu';
    }
  });

  const {
    getShowSystemTitle
  } = useHeaderSetting();
</script>

<style type="text/css" lang="less">
  @prefix-cls: ~'@{namespace}-layout-left-menu';
  .vben-layout-left-menu.mix{
    .title-bar.vben-layout-menu-logo{
      img{
        margin-right: 20px;
      }
    }
  }


  .@{prefix-cls} {
    --left-menu-width: 200px;
    color: #fff;
    font-size: 14px;
    height: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: width cubic-bezier(0.2, 0, 0, 1) 0.2s;
    background-color: var(--sider-dark-bg-color, #020021);

    &.LayoutLeftMenu-light{
      color: #444;
      .arch-menu {
        .arch-menu-item {
          color: #444;
        }
      }
    }

    &.lightMenu {
      color: #444;
    }

    .@{prefix-cls}-menu-body {
      padding: 6px;
    }

    .title-bar {
      height: 48px;
      overflow: hidden;
    }

    .app-title {
      line-height: 44px;
      font-size: 16px;
      padding: 0px 12px;
      font-weight: 700;
      transition: all 0.5s;
    }

    &.expand {
      width: var(--left-menu-width, 200px);
    }

    &.mix {
      width: 55px;
    }

    &.lightMenu {
      .arch-menu {
        .arch-menu-item.selected {
          background: #383f45;
          color: #fff;
        }
      }
    }
    &.drakMenu {
      .arch-menu {
        .arch-menu-item.selected {
          background: #edeced;
          color: #333;
        }
      }
    }

    .arch-menu {
      padding: 4px 0;

      .arch-menu-item {
        display: flex;
        align-items: center;
        padding-left: 12px;
        padding-right: 8px;
        height: 40px;
        color: hsla(0, 0%, 100%, 0.8);
        outline: none;
        cursor: pointer;
        transition: background 0.3s, color 0.3s;

        &.selected {
          font-weight: 500;
        }

        .arch-menu-item-text {
          padding: 0 14px;
          transition: background 0.3s, color 0.3s;
        }
      }
    }
  }
</style>
